module.exports = __webpack_public_path__ + "static/img/home_bottom_03.9d49c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_03.png
// module id = EPcx
// module chunks = 1